module.exports = __webpack_public_path__ + "static/usa-news-banner-cce799aec803391b2714b989cec9e4e4.svg";